module.exports = __webpack_public_path__ + "media/a4.1b7732dc.wav";